import { ArrowRightIcon, Button, Spinner } from '@farol-ds/react'
import { useIsomorphicLayoutEffect } from '@jusbrasil-web/shared-utils-events'
import { useCallback, useRef, useState } from 'react'

import { getUserQuestion } from '../../pages/teses-juridicas-chat/messages'
import styles from './static-chat-input.module.scss'

export interface StaticChatInputProps {
  onSubmitInput?: () => void
  clusterLabel: string
}

export function StaticChatInput(props: StaticChatInputProps) {
  const { onSubmitInput, clusterLabel } = props

  const textareaRef = useRef<HTMLTextAreaElement>(null)
  const [isRedirecting, setIsRedirecting] = useState(false)

  const getURLChatJusia = useCallback(() => {
    const userQuestion = getUserQuestion(clusterLabel)
    console.log(textareaRef.current?.value)
    const textInput = textareaRef.current?.value ?? ''
    const contextMessage = `${userQuestion}\n\nTambém gostaria de uma resposta para:\n${textInput}`

    const URL_CHAT_JUSIA = 'https://ia.jusbrasil.com.br/conversa'
    return `${URL_CHAT_JUSIA}?q=${encodeURIComponent(contextMessage)}&send`
  }, [clusterLabel, textareaRef])

  const onSubmit = useCallback(() => {
    setIsRedirecting(true)
    if (onSubmitInput) {
      onSubmitInput()
    }
    window.location.href = getURLChatJusia()
  }, [onSubmitInput, getURLChatJusia])

  const onEnter = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        onSubmit()
        e.preventDefault()
      }
    },
    [onSubmit]
  )

  const handleInput = () => {
    const textarea = textareaRef.current
    if (!textarea) return

    textarea.style.height = 'auto'
    textarea.style.height = textarea.scrollHeight + 'px'
  }

  useIsomorphicLayoutEffect(() => {
    const textarea = textareaRef.current
    if (!textarea) return
    textarea.addEventListener('keydown', onEnter)
    return () => {
      textarea.removeEventListener('keydown', onEnter)
    }
  }, [onEnter])

  return (
    <div className={styles.container}>
      <textarea
        ref={textareaRef}
        disabled={isRedirecting}
        className={styles.input}
        placeholder="Fazer pergunta ao Jus IA"
        rows={1}
        onInput={handleInput}
        data-testid="static-chat-input"
      />
      {!isRedirecting ? (
        <Button
          kind="tertiary"
          className={styles.submit}
          size="md"
          onClick={onSubmit}
          data-testid="static-chat-input-button"
        >
          <ArrowRightIcon />
        </Button>
      ) : (
        <Spinner size="sm" />
      )}
    </div>
  )
}
